import React, {forwardRef} from 'react';
import {translateNativeBase} from "../../../services/nativeBaseTranslator";

const VStack = forwardRef((props, ref) => {
    const { children, key, nativeID, style = {}, ...rest } = props;
    return (
        <div key={key} id={nativeID} ref={ref} style={{display: "flex", flexDirection: 'column', ...translateNativeBase({...rest}), ...style}}>
            {children}
        </div>
    );
});

export default VStack;